import { makeStyles } from '@material-ui/styles';

import { red, green, neutral } from 'shared/styles/colors';

export default makeStyles({
  radioGroup: {
    gap: '1rem',
  },
  legend: {
    marginBottom: '0.5rem',
    fontWeight: 500,
    lineHeight: '1rem',
    fontSize: '0.75rem',
    color: neutral['100'],
    '&.Mui-focused': {
      color: neutral['100'],
    },
  },
  customDateMsg: {
    padding: '0.5rem',
    fontSize: '0.75rem',
    lineHeight: '1rem',
    textAlign: 'center',
    borderRadius: '0.5rem',
    backgroundColor: green['10'],
    '&[data-has-custom-date="false"]': {
      backgroundColor: red['10'],
    },
    '& > span': {
      fontWeight: 500,
    },
  },
});
